import type { ApiConfig } from '@api/types';
import { typedMethodPost } from '@api/utils';
import type {
  AddProductionInformationRequestDto,
  CorrectQuantityRequestDto,
  ScheduleProductionOperationRequestDto,
  CloseProductionOperationRequestDto,
  ResetScheduleProductionOperationRequestDto,
} from '../../generated/models';

export default ({ baseURL }: ApiConfig) => ({
  addProductionInformation: typedMethodPost<AddProductionInformationRequestDto, void>(
    (data) =>
      fetch(`${baseURL}/v1/productionInformation/addProductionInformation`, {
        method: 'POST',
        ...data,
      })
  ),
  correctQuantity: typedMethodPost<CorrectQuantityRequestDto, void>(
    (data) =>
      fetch(`${baseURL}/v1/productionInformation/correctQuantity`, {
        method: 'POST',
        ...data,
      })
  ),
  scheduleProductionOperation: typedMethodPost<ScheduleProductionOperationRequestDto, void>(
    (data) =>
      fetch(`${baseURL}/v1/productionInformation/scheduleProductionOperation`, {
        method: 'POST',
        ...data,
      })
  ),
  closeProductionOperation: typedMethodPost<CloseProductionOperationRequestDto, void>(
    (data) =>
      fetch(`${baseURL}/v1/productionInformation/closeProductionOperation`, {
        method: 'POST',
        ...data,
      })
  ),
  resetScheduleProductionOperation: typedMethodPost<ResetScheduleProductionOperationRequestDto, void>(
    (data) =>
      fetch(`${baseURL}/v1/productionInformation/resetScheduleProductionOperation`, {
        method: 'POST',
        ...data,
      })
  ),
});

// Re-export types for consumers
export type {
  AddProductionInformationRequestDto,
  CorrectQuantityRequestDto,
  ScheduleProductionOperationRequestDto,
  CloseProductionOperationRequestDto,
  ResetScheduleProductionOperationRequestDto,
};
